const isEanbled = (property: string) => property === 'true'

type Config = {
  testKey: string
  environment: string
  googleApiUrl: string
  baseUrl: string
  baseAuth: string
  baseApiKey: string
  s3Download: {
    baseS3ApiKey: string
    baseS3Auth: string
  }
  login:{
    url: string
    auth: string
    apiKey: string
  }
  userv2:{
    url:string
    apiKey:string
  }
  oauth: {
    clientId: string
    oauthUrl: string
    authFlow: string
  }
  wholeSaleWebUser: {
    url: string
    redirectUri: string
  }
  wos: {
    url: string
    apiKey: string
    token: string
  }
  features: {
    roleCheckEnabled: boolean
  }
}

export const config: Config = {
  testKey: import.meta.env.VITE_TEST_KEY,
  environment: import.meta.env.VITE_APP_ENV,
  googleApiUrl: import.meta.env.VITE_GOOGLE_API_BASE_URL,
  baseUrl: import.meta.env.VITE_BASE_URL,
  baseAuth: import.meta.env.VITE_BASE_AUTH,
  baseApiKey: import.meta.env.VITE_BASE_API_KEY,
  s3Download: {
    baseS3ApiKey: import.meta.env.VITE_BASE_S3_API_KEY,
    baseS3Auth: import.meta.env.VITE_BASE_S3_AUTH,
  },
  login:{
    url: import.meta.env.VITE_BASE_LOGIN_URL,
    auth: import.meta.env.VITE_BASE_LOGIN_AUTH,
    apiKey: import.meta.env.VITE_BASE_LOGIN_API_KEY
  },
  userv2:{
    url:import.meta.env.VITE_USERV2_BASE_URL,
    apiKey:import.meta.env.VITE_USERV2_API_KEY
  },
  oauth: {
    clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    oauthUrl: import.meta.env.VITE_OAUTH_SERVER_URL,
    authFlow: import.meta.env.VITE_AUTH_FLOW,
  },
  wholeSaleWebUser: {
    url: import.meta.env.VITE_USER_MANAGEMENT_URL,
    redirectUri: import.meta.env.VITE_USER_MANAGEMENT_REDIRECT_URI,
  },
  wos: {
    url: import.meta.env.VITE_WOS_BASE_URL,
    apiKey: import.meta.env.VITE_WOS_API_KEY,
    token: import.meta.env.VITE_WOS_AUTH_TOKEN,
  },
  features: {
    roleCheckEnabled: isEanbled(import.meta.env.VITE_ROLE_CHECK_ENABLED),
  },
}
